// **********************************************************
// Cart View
// **********************************************************
const cartModule = document.querySelector('.cart-module');
const cartPopupContent = document.querySelector('.cart-popup');
const checkoutCart = document.querySelector('.purchase-process-sidebar');

const updateCartPopupEmptyTitle = (title) => {
  if (!title) {
    return;
  }
  document.querySelectorAll('.cart-popup__empty .cart-popup__title h2').forEach((element) => {
    element.textContent = title;
  });
};

// Axios remove item from cart
const axiosRemoveItemFromCart = async (itemKey, source) => {
  const formDataInput = new FormData();
  formDataInput.append('action', 'removeItemFromCart');
  formDataInput.append('item_key', itemKey);
  formDataInput.append('source', source);
  formDataInput.append('current', document.querySelector('.free-shipping-indicator__progress-bar-inner')?.style.width);
  if (source === 'checkout') {
    formDataInput.append('perks', JSON.stringify(getInputData()));
  }

  const currentValue =
    document.querySelector('.cart-module__amount-row-right')?.innerHTML.trim() ||
    document.querySelector('.cart-popup__total-row input')?.value.trim() ||
    0;
  try {
    const response = await axios.post(localData.apiURL, formDataInput);
    if (source === 'checkout' && !response.data.data.cart_contents_count) {
      window.location.reload();
      return;
    }
    updateCartOnChange(response.data.data.cart_content_html, source);
    updateCartNumber(response.data.data.cart_contents_count);
    updateCartPopupEmptyTitle(response.data.data.cart_title);
    if (source === 'checkout') {
      promoCodeSuccess(
        response.data.data.cart_prices_html,
        response.data.data.free_shipping_indicator_html,
        response.data.data.delivery_prices,
        response,
      );
      await axiosCalculateTotals();
      if (document.querySelector('.sc-purchase-process-info-02')) {
        reInitPayMethods();
      }
      return;
    }
    setTimeout(() => {
      const progressBars = document.querySelectorAll('.free-shipping-indicator__progress-bar');
      progressBars.forEach((bar) => {
        const inner = bar.querySelector('.free-shipping-indicator__progress-bar-inner');
        if (inner && bar.dataset.end) {
          inner.style.width = `${bar.dataset.end}%`;
        }
      });
    }, 20);
    animateNumbersValue(currentValue);
  } catch (err) {
    console.error(err);
  }
};

const handleDeleteClick = (ev) => {
  if (ev.target.closest('.cart-view__delete')) {
    ev.preventDefault();
    const parentElem = ev.target.closest('.cart-view__item');
    const itemKey = parentElem.querySelector('.cart-item-key')?.value;
    if (!itemKey) {
      return;
    }
    const source = ev.target.closest('.purchase-process-sidebar')
      ? 'checkout'
      : ev.target.closest('.cart-module') ? 'cartPage' : 'popup';
    if (source === 'checkout') {
      axiosRemoveItemFromCart(itemKey, source);
      return;
    }
    parentElem.remove();

    if (source === 'cartPage') {
      if (cartModule.querySelectorAll('.cart-view__item').length === 0) {
        cartModule.classList.add('cart-module--empty');
      }
    } else if (cartPopupContent?.querySelectorAll('.cart-view__item').length === 0) {
      cartPopupContent.classList.add('cart-popup--empty');
    }

    axiosRemoveItemFromCart(itemKey, source);
  }
};

if (cartModule) {
  cartModule.addEventListener('click', handleDeleteClick);
}

if (cartPopupContent) {
  cartPopupContent.addEventListener('click', handleDeleteClick);
}

if (checkoutCart) {
  checkoutCart.addEventListener('click', handleDeleteClick);
}
